module.exports = __webpack_public_path__ + "static/media/0324_IMG_LES_MURS_CHROMATIC_CH2_1066.74ae3646.png";